import baseMixin from './baseMixin'
import { tween, styler, action } from 'popmotion'
import { shuffle } from 'lodash'

export default {
    mixins: [baseMixin],

    beforeCreate() {
        this.baseElementQueryString = 'security-policy-graphic'
    },

    methods: {
        setStyler() {
            const brickEls = this.baseElement.querySelectorAll('path')
            const elsAndRects = []
            brickEls.forEach(el => {
                try {
                    let rect = el.getBBox()
                    elsAndRects.push({
                        el,
                        y: rect.y
                    })
                } catch (e) {
                    // console.log('fcucked')
                }
            })

            this.bricks = elsAndRects
                .sort((a, b) => b.y - a.y)
                .map(o => styler(o.el))
        },

        initAction() {
            return tween({ from: { opacity: 1 }, to: { opacity: 0 } })
        },

        animationAction() {
            return action(({ update, complete }) => {
                let i = 0
                let interval = setInterval(() => {
                    if (i === this.bricks.length - 1) {
                        clearInterval(interval) // maybe not needed?
                        complete()
                    }
                    update(i++)
                }, 50)

                return {
                    stop: () => clearInterval(interval)
                }
            })
        },

        initReaction(v) {
            this.bricks.map(s => s.set(v))
        },

        animationReaction(i) {
            this.bricks[i].set({ opacity: 1 })
        }
    }
}
